import { CaseDraftDataWire } from "app/area/shared/case-draft-info-panel/types";

export const ACTION = {
  RequestLoadDraftsData: 'CASE_DRAFT_INFO:REQUEST_LOAD_DRAFTS_DATA',
  ReceiveLoadDraftsData: 'CASE_DRAFT_INFO:RECEIVE_LOAD_DRAFTS_DATA',
  FailLoadDraftsData: 'CASE_DRAFT_INFO:FAIL_LOAD_DRAFTS_DATA'
};

export class RequestLoadDraftsData {
  public type: string = ACTION.RequestLoadDraftsData;
}

export class ReceiveLoadDraftsData {
  public type: string = ACTION.ReceiveLoadDraftsData;
  constructor(public data: CaseDraftDataWire[]) {}
}

export class FailLoadDraftsData {
  public type: string = ACTION.FailLoadDraftsData;
}
